{
  "accountInformationText": "Update your personal account details below.",
  "accountSettings": "Account Settings",
  "accountStatus": "Account Status",
  "accountStatusText": "Your account is currently in good standing.",
  "active": "Active",
  "administrator": "Administrator",
  "backupCodeFailed": "Backup code verification failed.",
  "backupCodes": "Backup Codes",
  "backupCodesWarning": "Save these codes securely. Each backup code can only be used once.",
  "changePassword": "Change Password",
  "confirmPassword": "Confirm Password",
  "copyBackupCodes": "Copy Backup Codes",
  "currentPassword": "Current Password",
  "darkMode": "Dark Mode",
  "depositWithdrawalAlerts": "Deposit & Withdrawal Alerts",
  "disable2FA": "Disable 2FA",
  "disable2fa": "Disable Google Authenticator",
  "downloadBackupCodes": "Download Backup Codes",
  "emailNotifications": "Email Notifications",
  "enterAuthenticatorCode": "Enter the 6-digit code from your authenticator app",
  "enterAuthenticatorCodeFirst": "Please enter the authenticator code first.",
  "enterSixDigitCode": "Enter 6-digit code",
  "goToKycVerification": "Go to KYC Verification",
  "googleAuthenticator2fa": "Google Authenticator (2FA)",
  "googleAuthenticator2faText": "Add an extra layer of security to your account using Google Authenticator.",
  "googleAuthenticatorDisabled": "Google Authenticator has been disabled.",
  "googleAuthenticatorEnabled": "Google Authenticator has been enabled.",
  "inactive": "Inactive",
  "invalidCode": "Invalid code. Please try again.",
  "invalidVerificationCode": "Invalid verification code.",
  "kycStatusText": "Complete identity verification to unlock full account features.",
  "language": "Language",
  "languagePreferencesText": "Choose the language used across your account.",
  "languageSettings": "Language Settings",
  "lightMode": "Light Mode",
  "loading": "Loading...",
  "loginAlerts": "Login Alerts",
  "manualSetupKey": "Manual Setup Key",
  "newBackupCodesGenerated": "New backup codes generated. Save them in a safe place.",
  "newPassword": "New Password",
  "notificationPreferences": "Notification Preferences",
  "notificationPreferencesText": "Choose which alerts you want to receive.",
  "notificationSettings": "Notification Settings",
  "owner": "Owner",
  "ownerControlCenter": "Owner Control Center",
  "ownerDisableBlocked": "Owner account cannot disable Google Authenticator.",
  "p2pAlerts": "P2P Alerts",
  "p2pOrderAlerts": "P2P Order Alerts",
  "pushNotifications": "Push Notifications",
  "regenerateBackupCodes": "Regenerate Backup Codes",
  "require2FASetup": "Google Authenticator setup is required before continuing.",
  "role": "Role",
  "saveBackupCodes": "Save Backup Codes",
  "saveChanges": "Save Changes",
  "saving": "Saving...",
  "scanQrCode": "Scan this QR Code",
  "scanQrCodeAuthenticator": "Scan this QR code with your authenticator app",
  "securityAlerts": "Security Alerts",
  "securityRules": "Security Rules",
  "securitySettings": "Security Settings",
  "selectLanguage": "Select Language",
  "serverError": "Server error.",
  "sessionExpired": "Session expired. Please login again.",
  "settingRuleBotProtection": "Automated bot-activity protection is active on this account.",
  "settingRuleDepositReview": "Large deposits are reviewed before crediting your balance.",
  "settingRuleKyc": "Identity verification is required before withdrawals are approved.",
  "settingRuleManualReview": "Suspicious activity may trigger a manual security review.",
  "settingRuleWalletMatch": "Withdrawals must match a verified wallet address.",
  "settingsSubtitle": "Manage your account, language, authentication and security.",
  "settingsTitle": "Settings & Security",
  "settingsUpdateFailed": "Failed to update settings.",
  "settingsUpdated": "Settings updated successfully.",
  "setup2FA": "Setup Google Authenticator",
  "setupGoogleAuthenticator": "Set Up Google Authenticator",
  "systemDefault": "System Default",
  "theme": "Theme",
  "twoFaSetupFailed": "Two-factor authentication setup failed.",
  "twoFactorAuthentication": "Google Authenticator (2FA)",
  "twoFactorDescription": "Protect your account using Google Authenticator.",
  "twoFactorDisabled": "Two-Factor Authentication Disabled",
  "twoFactorDisabledSuccess": "Google Authenticator disabled successfully.",
  "twoFactorEnabled": "Two-Factor Authentication Enabled",
  "twoFactorSecurity": "Two-Factor Security",
  "twoFactorSecurityText": "Enable two-factor authentication for stronger account protection.",
  "twoFactorSetupFailed": "2FA setup failed.",
  "twoFactorVerified": "Google Authenticator enabled successfully.",
  "user": "User",
  "verificationCode": "Verification Code",
  "verify2FA": "Verify & Enable",
  "verifyAndEnable": "Verify & Enable"
}